module.exports = __webpack_public_path__ + "static/media/icon.c639428f.png";